import { createContext, useContext, useState } from "react";

type IKycPollingContext = {
  shouldPoll: boolean;
  startPolling: () => void;
  stopPolling: () => void;
};

type IKycPollingProvider = {
  children: React.ReactNode;
};

const KycPollingContext = createContext<IKycPollingContext>({
  shouldPoll: false,
  startPolling: () => {},
  stopPolling: () => {},
});

export function KycPollingProvider({ children }: IKycPollingProvider) {
  const [shouldPoll, setShouldPoll] = useState(false);

  return (
    <KycPollingContext.Provider
      value={{
        shouldPoll,
        startPolling: () => setShouldPoll(true),
        stopPolling: () => setShouldPoll(false),
      }}
    >
      {children}
    </KycPollingContext.Provider>
  );
}

export function useKycContext() {
  const context = useContext(KycPollingContext);

  if (context === undefined) {
    throw new Error("useKycContext must be used withing an KycPollingProvider");
  }

  return context;
}
